var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404 - Página não encontrada")]),_c('p',[_vm._v("A página que você tentou acessar não existe ou foi movida.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Voltar para a página inicial")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }